import React, {
  useEffect,
  useMemo,
  useCallback,
  useState,
  useRef,
} from "react";
import { Button, Col, Row, Modal, Form } from "react-bootstrap";
import Switch from "react-switch";
import Split from "react-split";
import {
  EditableFieldAmount,
  EditableFieldDateYYYYMMDD,
  EditableFieldText,
} from "../../../../utils/EditableField";
// import NewTransactionTable from "./NewTransactionTable";
import { datefilterParamsYYYYMMDD } from "../../Analyze/AnalyzeTransactionsTable";

import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import {
  fetchMfs,
  fetchTls,
  setSelectedChunk,
  setSelectedFieldNames,
  setSelectedTransactionStatus,
  setTls,
  toggleLoading,
  setRefreshKey,
  setAccountChunks,
  setSelectedDocumentId,
  setSelectedAccount,
  setGridApi,
} from "../../../../redux/reducers/TransactionManager";
import { fetchTotals } from "../../../../redux/reducers/Reconciler";
import {
  createCorrection,
  createCorrectionTagLevel,
  performBulkEdit,
  performBulkEditTagLevel,
} from "../../../../docuclipper/api";
import { createAlert } from "../../../../redux/reducers/Alerts";
import { isArray } from "lodash";
import SummaryTableAccountViewHorizontal2 from "./SummaryTableAccountViewHorizontal2";
import { getDocumentName } from "../../Analyze/AnalyzeTransactionsTable/utils";
import ExternalFilter from "src/views/Docuclipper/ExternalFilter";
import {
  setExternalFiltersColumnDefs,
  clearExternalFilters,
} from "src/redux/reducers/ExternalFilter";
import PDFViewer from "../../PdfViewer";
import useBankStatementPDF from "./useBankStatementPDF";
import { isNullOrUndefined, useHasQbo } from "src/utils/utils";
import { GridReadyEvent } from "ag-grid-community";
import { IDatasource } from "ag-grid-community";
import ColumnSelector from "./ColumnSelector";
import {
  setColumnWidth,
  setColumns,
} from "../../../../redux/reducers/AgGridColumnConfig";
import PayeeCleanerConfig from "./PayeeCleanerConfig";
import { AddTransactionModal } from "./AddTransaction";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SelectAccount2 from "./ReassignAccount/SelectAccount2";
import AgBulkTable from "../../Analyze/AnalyzeTransactionsTable/AgBulkTable";
import { TableFilterConfig } from "src/docuclipper/DocuclipperTypes";
import { useLocation, useHistory } from "react-router-dom";
import { DownloadModal } from "./DownloadModal";
import { convertFilterModel, convertSortModel } from "src/utils/filters";
import AddDocumentsPopover from "./AddBankStatementsPdfCsvPopover";
import TransactionManagerTourAndReportIssue from "./TransactionManagerTour";
import HelpDrawer from "src/views/Docuclipper/Ratings/HelpDrawer";
import { FixBankPageWithAIButton } from "../../../../components/FixBankPageWithAIButton";
import { useIsAdmin } from "src/utils/auth";
import { useChunkData } from "../../Analyze/AnalyzeTransactionsTable/hooks";
import PresignedDocumentViewer from "../../PdfViewer/PresignedDocumentViewer";

type Props = { hideJobButtons: boolean };
export const NewTransactionManager: React.FC<Props> = ({ hideJobButtons }) => {
  const job = useSelector((state: ReduxState) => state.JobData.job);
  const { data: jobDocs, loading } = useSelector(
    (state: ReduxState) => state.JobDocument
  );

  const {
    selectedDocumentId,
    tls,
    selectedChunk,
    // accountChunkLabels,
    selectedAccount,
    pagination,
    refreshKey,
    // accountChunks,
  } = useSelector((state: ReduxState) => state.TransactionManager);

  // const isCSV = job?.metadata?.includes("csv2QboMapping");
  // console.log({ jobDocs });

  const selectedDoc = (jobDocs || []).filter(
    (x) => x.documentId.toString() === (selectedDocumentId || "").toString()
  );

  // Check if the document is viewable (PDF or image)
  const isViewableDocument = (mimetype: string): boolean => {
    return mimetype.includes("pdf") || mimetype.startsWith("image/");
  };

  const isCSV =
    selectedDoc.length > 0
      ? !isViewableDocument(selectedDoc[0].mimetype)
      : false;

  // console.log({ isCSV, selectedDoc, jobDocs, selectedDocumentId });
  // const chunkData = useChunkData();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { externalFilters } = useSelector(
    (state: ReduxState) => state.ExternalFilter
  );

  const { selectedL1: l1, selectedL2: l2 } = useSelector(
    (state: ReduxState) => state.TagLevel
  );

  // Get l1 and l2 from URL query params
  const searchParams = new URLSearchParams(location.search);
  const urlL1 = searchParams.get("l1");
  const urlL2 = searchParams.get("l2");

  const handleAddBankStatementsPDF = () => {
    if (urlL1 && urlL2) {
      history.push(
        `/extract/bankMode?l1=${encodeURIComponent(urlL1)}&l2=${encodeURIComponent(urlL2)}`
      );
    }
  };

  const handleAddBankStatementsCSV = () => {
    if (urlL1 && urlL2) {
      history.push(
        `/extract/csv2qbo?l1=${encodeURIComponent(urlL1)}&l2=${encodeURIComponent(urlL2)}`
      );
    }
  };

  const handleDocumentAction = (path: string) => {
    const queryParams =
      l1 && l2
        ? `?l1=${encodeURIComponent(l1)}&l2=${encodeURIComponent(l2)}`
        : "";
    history.push(`${path}${queryParams}`);
  };

  // Empty State Component
  const EmptyStateComponent = () => (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "400px" }}
    >
      <div className="text-center mb-4">
        <FontAwesomeIcon
          icon="file-alt"
          size="4x"
          className="text-muted mb-3"
        />
        <h4 className="text-muted">No Bank Statements Found</h4>
        <p className="text-muted">
          Get started by adding your bank statements or transaction files
        </p>
      </div>

      <div className="d-flex">
        <Button
          variant="primary"
          size="lg"
          onClick={() => handleDocumentAction("/extract/bankMode/")}
          className="d-flex flex-column align-items-center p-4"
          style={{ minWidth: "200px" }}
        >
          <FontAwesomeIcon icon="university" size="2x" className="mb-2" />
          <strong>Bank/CC Transactions</strong>
          <small className="mt-1">Upload PDF files</small>
        </Button>

        <Button
          variant="outline-primary"
          size="lg"
          onClick={() => handleDocumentAction("/extract/csv2qbo/")}
          className="d-flex flex-column align-items-center p-4 ml-3"
          style={{ minWidth: "200px" }}
        >
          <FontAwesomeIcon icon="file-alt" size="2x" className="mb-2" />
          <strong>Bank Transactions</strong>
          <small className="mt-1">Upload CSV files</small>
        </Button>
      </div>
    </div>
  );

  const PageNumberCellRenderer = (props) => {
    if (!props.data) return "";
    return <span>{parseInt(props.data.pageNumber.toString(), 10) + 1}</span>;
  };

  const SwitchCellRenderer = (props) => {
    const [included, setIncluded] = React.useState(
      props.data ? props.data.included : false
    );

    if (!props.data) return "";
    const { documentId, fieldName, rowNumber } = props.data;

    return (
      <Switch
        key={included}
        checked={included}
        onChange={(e) => {
          dispatch(toggleLoading());
          const fn =
            l1 && l2
              ? createCorrectionTagLevel(
                  documentId,
                  l1,
                  l2,
                  fieldName,
                  rowNumber,
                  -1,
                  null,
                  !included,
                  false,
                  false
                )
              : job && job.id
              ? createCorrection(
                  job.id,
                  documentId,
                  fieldName,
                  rowNumber,
                  -1,
                  null,
                  !included,
                  false,
                  false
                )
              : Promise.resolve({ transactions: [] });
          fn.then(({ transactions }) => {
            // dispatch(setRefreshKey());
            setIncluded(!included);
            dispatch(toggleLoading());
            dispatch(setTls({ transactions, resetPages: false }));
            dispatch(fetchMfs());
            dispatch(fetchTotals());

            dispatch(
              createAlert({
                message: "Included transactions updated successfully",
                timeout: 0,
                type: "success",
              })
            );
          }).catch(() => {
            dispatch(toggleLoading());
            dispatch(
              createAlert({
                message: "Error updating included transactions",
                timeout: 0,
                type: "error",
              })
            );
          });
        }}
        onColor="#86d3ff"
        onHandleColor="#2693e6"
        handleDiameter={15}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
        height={10}
        width={30}
        className="react-switch"
        id="material-switch"
      />
    );
  };

  const EditableQboField = (props) => {
    const { field, fieldType, value } = props;

    const [value2, setValue2] = React.useState(value);

    if (!props.data) return "";

    const createCorrectionHelper = (
      newText,
      toggleSign,
      divideBy100,
      multilineIndex
    ) => {
      const values = props.data;
      const { documentId, fieldName, rowNumber, columnMapping, included } =
        values;

      // if (!job) {
      //   // console.warn("No job found, cannot create correction");
      //   return;
      // }

      // console.log("Creating correction with params:", {
      //   jobId: job.id,
      //   documentId,
      //   fieldName,
      //   rowNumber,
      //   columnIndex: columnMapping[props.field],
      //   newText,
      //   included,
      //   toggleSign,
      //   divideBy100,
      //   multilineIndex,
      // });
      dispatch(toggleLoading());
      const fn =
        l1 && l2
          ? createCorrectionTagLevel(
              documentId,
              l1,
              l2,
              fieldName,
              rowNumber,
              columnMapping[props.field],
              newText,
              included,
              toggleSign,
              divideBy100,
              multilineIndex
            )
          : job && job.id
          ? createCorrection(
              job.id,
              documentId,
              fieldName,
              rowNumber,
              columnMapping[props.field],
              newText,
              included,
              toggleSign,
              divideBy100,
              multilineIndex
            )
          : Promise.resolve({ transactions: [] });

      fn.then(({ transactions }) => {
        dispatch(toggleLoading());
        // // dispatch(setTls({ transactions, resetPages: false }));
        // dispatch(setRefreshKey());

        dispatch(fetchTotals());
        dispatch(fetchMfs());
        dispatch(
          createAlert({
            message: "Transaction fixed",
            timeout: 0,
            type: "success",
          })
        );
        if (gridApi.current) {
          gridApi.current.purgeInfiniteCache();
        }
      }).catch(() => {
        dispatch(toggleLoading());
        dispatch(
          createAlert({
            message: "Error fixing transaction",
            timeout: 0,
            type: "error",
          })
        );
      });
    };

    if (fieldType === "date") {
      return (
        <EditableFieldDateYYYYMMDD
          onSave={(newValue) => {
            createCorrectionHelper(newValue, false, false, null);
          }}
          value={value}
        />
      );
    } else if (fieldType === "number") {
      if (["amount", "balance", "debit", "credit"].includes(field)) {
        return (
          <Row className="align-items-center justify-content-between">
            <Col>
              <EditableFieldAmount
                key={value2}
                onSave={(newValue) => {
                  createCorrectionHelper(newValue, false, false, null);
                }}
                value={value2}
              />
            </Col>
            <Col className="px-0">
              <Button
                className="p-0"
                variant="light"
                size="sm"
                onClick={() => {
                  createCorrectionHelper("", true, false, null);
                }}
              >
                +/-
              </Button>
              <Button
                className="p-0 ml-2"
                variant="light"
                size="sm"
                onClick={() => {
                  createCorrectionHelper("", false, true, null);
                }}
              >
                .00
              </Button>
            </Col>
          </Row>
        );
      } else {
        return (
          <EditableFieldAmount
            onSave={(newValue) =>
              createCorrectionHelper(newValue, false, false, null)
            }
            value={value}
          />
        );
      }
    } else {
      // text
      if (isArray(value)) {
        const concatenatedValue = value.join(" ");
        return (
          <EditableFieldText
            onSave={(newValue) => {
              createCorrectionHelper(newValue, false, false, 0);
            }}
            value={concatenatedValue}
            multiline={true}
            placement="top"
          />
        );
      } else {
        return (
          <EditableFieldText
            onSave={(newValue) =>
              createCorrectionHelper(newValue, false, false, null)
            }
            value={value}
          />
        );
      }
    }
  };

  // Helper function to check if a transaction is AI-generated
  // Checks the metadata field (JSON string) for aiGenerated: true property
  const isAIGenerated = (rowData: any) => {
    if (!rowData || !rowData.metadata) return false;

    try {
      const metadata =
        typeof rowData.metadata === "string"
          ? JSON.parse(rowData.metadata)
          : rowData.metadata;
      return metadata.aiGenerated === true;
    } catch (err) {
      return false;
    }
  };

  // Row class helper for AI-generated styling
  // Applies 'ai-generated-row' CSS class to rows with AI-generated transactions
  const getRowClass = (params: any) => {
    const baseClass = "";
    if (isAIGenerated(params.data)) {
      return baseClass + " ai-generated-row";
    }
    return baseClass;
  };

  const defaultColumnDefs = [
    // {
    //   field: "selection",
    //   headerCheckboxSelection: true,
    //   checkboxSelection: true,
    //   width: 40,
    //   minWidth: 40,
    //   maxWidth: 40,
    //   pinned: "left",
    //   lockPosition: true,
    //   suppressMenu: true,
    //   index: -1,
    // },
    {
      field: "included",
      headerName: "Included",
      minWidth: 100,
      maxWidth: 100,
      cellRenderer: SwitchCellRenderer,
      cellClass: "ag-grid-cell-included",
      index: 0,
    },
    {
      field: "pageNumber",
      headerName: "PN",
      filter: "agNumberColumnFilter",
      sortable: true,
      minWidth: 75,
      maxWidth: 75,
      cellRenderer: PageNumberCellRenderer,
      index: 1,
    },
    {
      key: "documentDate",
      field: "date",
      filter: "agDateColumnFilter",
      filterParams: datefilterParamsYYYYMMDD,
      sortable: true,
      minWidth: 150,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "date",
        fieldType: "date",
      },
      cellClass: "ag-grid-cell-date",
      configurable: true,
      index: 2,
    },
    {
      key: "documentDate2",
      field: "date2",
      filter: "agDateColumnFilter",
      filterParams: datefilterParamsYYYYMMDD,
      sortable: true,
      minWidth: 150,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "date2",
        fieldType: "date",
      },
      configurable: true,
      index: 3,
    },
    {
      key: "documentPayee",
      field: "payee",
      filterParams: {},
      minWidth: 200,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "payee",
        fieldType: "text",
      },
      configurable: true,
      index: 4,
    },
    {
      key: "documentDescription",
      field: "description",
      filterParams: {},
      minWidth: 400,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "name",
        fieldType: "text",
      },
      configurable: true,
      index: 5,
    },
    {
      key: "documentAmount",
      field: "amount",
      sortable: true,
      minWidth: 250,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "amount",
        fieldType: "number",
      },
      configurable: true,
      index: 6,
      filter: "agNumberColumnFilter", // Make sure this is set correctly
      // filterParams: {
      //   filterOptions: ['equals', 'lessThan', 'greaterThan', 'inRange'],
      //   defaultOption: 'equals'
      // }
    },
    {
      key: "documentBalance",
      field: "balance",
      filter: "agNumberColumnFilter", // Make sure this is set correctly
      filterParams: {},
      minWidth: 250,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "balance",
        fieldType: "number",
      },
      configurable: true,
      index: 7,
    },
    {
      key: "documentCheckNumber",
      field: "checkNumber",
      filterParams: {},
      minWidth: 150,
      cellRenderer: EditableQboField,
      cellRendererParams: {
        field: "checkNumber",
        fieldType: "text",
      },
      configurable: true,
      index: 8,
    },
  ];

  const reduxColumnDefs =
    useSelector(
      (state: ReduxState) => state.AgGridColumnConfig.transactionManager
    ) || [];

  const initialColumnDefs = useMemo(() => {
    if (reduxColumnDefs.length === 0) {
      const defaultColumns = defaultColumnDefs.map((col) => ({
        ...col,
        hide: false,
        width: (col as any).width,
      }));

      dispatch(
        setColumns({
          tableId: "transactionManager",
          columns: defaultColumns as any,
        })
      );
      return defaultColumns;
    }

    // Sort columns by index
    return reduxColumnDefs
      .slice()
      .sort((a, b) => (a as any).index - (b as any).index) // Sort by index
      .map((reduxCol) => {
        const defaultCol = defaultColumnDefs.find(
          (col) => col.field === reduxCol.field
        );
        return {
          ...defaultCol,
          hide:
            reduxCol.hide !== undefined
              ? reduxCol.hide
              : (defaultCol as any).hide,
          width:
            reduxCol.width !== undefined
              ? reduxCol.width
              : (defaultCol as any).width,
        };
      });
  }, [reduxColumnDefs, dispatch]);

  const defaultColDef = React.useMemo(() => {
    return {
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      filter: true,
    };
  }, []);

  const { totalsByChunk } = useSelector(
    (state: ReduxState) => state.Reconciler
  );

  useEffect(() => {
    return () => {
      dispatch(setSelectedDocumentId(null)); // Assuming this action exists
      dispatch(setSelectedChunk(null));
      dispatch(setSelectedAccount(null));
    };
  }, []);

  // console.log({ accountChunks });
  const { documents } = tls;

  // console.log({ job });
  React.useEffect(() => {
    // console.log("fetching totals");
    dispatch(fetchMfs());
    dispatch(fetchTotals());
  }, [job]);
  const gridApi = useRef<any>(null);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);

  // Store the API instance in Redux when it changes
  useEffect(() => {
    if (gridApi.current) {
      dispatch(setGridApi(gridApi.current));
    }
  }, [dispatch, gridApi.current]);

  const externalFilterColumns = React.useMemo(
    () => [
      {
        field: "pageNumber",
        label: "Page Number",
        filter: true,
        filterType: "number",
        defaultFilterType: "equals",
      },
      {
        field: "description",
        label: "Description",
        filter: true,
        configurable: true,
        filterType: "text",
        defaultFilterType: "contains",
      },
      {
        field: "amount",
        label: "Amount",
        filter: true,
        filterType: "number",
        defaultFilterType: "equals",
        configurable: true,
      },
      {
        field: "date",
        label: "Date",
        filter: true,
        filterType: "date",
        defaultFilterType: "equals",
        configurable: true,
      },
      {
        field: "date2",
        label: "Date 2",
        filter: true,
        filterType: "date",
        defaultFilterType: "equals",
      },
      {
        field: "balance",
        label: "Balance",
        filter: true,
        filterType: "number",
        defaultFilterType: "equals",
      },
      {
        field: "checkNumber",
        label: "Check Number",
        filter: true,
        filterType: "text",
        defaultFilterType: "equals",
      },
    ],
    []
  );
  const { isAdmin, isSupportRep } = useIsAdmin();
  const chunkData = useChunkData();

  const paginationPageSizeSelector = React.useMemo(() => {
    return [20, 50, 100];
  }, []);

  useEffect(() => {
    dispatch(clearExternalFilters());
    dispatch(
      setExternalFiltersColumnDefs({
        externalFilterColumnDefs: initialColumnDefs,
      })
    );
  }, [selectedDocumentId]);

  const { pdfURL } = useBankStatementPDF({
    selectedDocumentId,
  });

  const onColumnResized = useCallback(
    (event) => {
      if (event.finished) {
        const columnState = event.columnApi.getColumnState();

        columnState.forEach((column) => {
          if (column.width) {
            dispatch(
              setColumnWidth({
                tableId: "transactionManager",
                field: column.colId,
                width: column.width,
              })
            );
          }
        });
      }
    },
    [dispatch]
  );

  const hasQbo = useHasQbo();

  // console.log({ selectedAccount, selectedChunk, selectedDocumentId });
  React.useEffect(() => {
    if (
      !isNullOrUndefined(selectedAccount) &&
      !isNullOrUndefined(selectedDocumentId) &&
      (selectedAccount || "") in totalsByChunk &&
      (selectedDocumentId || "") in totalsByChunk[selectedAccount || ""]
    ) {
      const chunksInAccount =
        totalsByChunk[selectedAccount || ""][selectedDocumentId || ""];
      const chunks = Object.keys(chunksInAccount);

      dispatch(setAccountChunks(chunks));
      if (chunks.length > 0 && !selectedChunk) {
        dispatch(setSelectedChunk(chunks[0]));
      }
    }
  }, [selectedAccount, selectedDocumentId, totalsByChunk]);

  // console.log({ selectedAccount, selectedChunk });
  const getRows = useCallback(
    (params) => {
      dispatch(
        fetchTls(false, {
          pagination: {
            page: Math.floor(params.startRow / pagination.pageSize) + 1,
            pageSize: params.endRow - params.startRow,
          },
          filters: [
            ...(selectedDocumentId
              ? [
                  {
                    field: "documentId",
                    operator: "equals" as const,
                    value: selectedDocumentId,
                  },
                ]
              : []),
            ...(selectedAccount
              ? [
                  {
                    field: "account",
                    operator: "equals" as const,
                    value: selectedAccount,
                  },
                ]
              : []),
            ...(selectedChunk
              ? [
                  {
                    field: "chunk",
                    operator: "equals" as const,
                    value: selectedChunk,
                  },
                ]
              : []),
            ...convertFilterModel(params),
          ],
          sorting: convertSortModel(params.sortModel),
          successCallback: (rowsThisPage, lastRow) => {
            // Process rows to include metadata for AI-generated detection
            const processedRows = rowsThisPage.map((row) => ({
              ...row,
              // Ensure metadata is available for AI detection
              metadata: row.metadata || null,
            }));
            params.successCallback(processedRows, lastRow);
          },
          documents,
          hasQbo,
          job,
          l1,
          l2,
        })
      );
    },
    [
      dispatch,
      pagination.pageSize,
      selectedDocumentId,
      selectedAccount,
      selectedChunk,
      documents,
      hasQbo,
      job,
      refreshKey,
      gridApi.current,
    ]
  );

  const dataSource: IDatasource = useMemo(
    () => ({
      rowCount: undefined,
      getRows,
    }),
    [getRows]
  );

  useEffect(() => {
    if (!gridApi.current) {
      return;
    }

    if (
      // !job ||
      // ["InProgress", "Finishing", "Canceled"].includes(job.status) ||
      isNullOrUndefined(selectedDocumentId) ||
      isNullOrUndefined(selectedAccount) ||
      isNullOrUndefined(selectedChunk)
    ) {
      return;
    }

    gridApi.current.setDatasource(dataSource);
  }, [
    job,
    selectedDocumentId,
    selectedAccount,
    selectedChunk,
    refreshKey,
    externalFilters,
    dataSource,
  ]);

  const [showColumnSelectorModal, setShowColumnSelectorModal] = useState(false);

  const handleShow = () => setShowColumnSelectorModal(true);
  const handleClose = () => setShowColumnSelectorModal(false);

  const tableId = "transactionManager";

  const [isSelectAllPages, setIsSelectAllPages] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [deselectedRows, setDeselectedRows] = useState<Set<string>>(new Set());

  const bulkEditHelper = (operation: string, transactionIds: any[]) => {
    if (isSelectAllPages) {
      dispatch(toggleLoading());

      // Get current filter model and sort model from the grid
      const filterParams = {
        filters: [
          ...(selectedDocumentId
            ? [
                {
                  field: "documentId",
                  operator: "equals" as const,
                  value: selectedDocumentId,
                },
              ]
            : []),
          ...(selectedAccount
            ? [
                {
                  field: "account",
                  operator: "equals" as const,
                  value: selectedAccount,
                },
              ]
            : []),
          ...(selectedChunk
            ? [
                {
                  field: "chunk",
                  operator: "equals" as const,
                  value: selectedChunk,
                },
              ]
            : []),
          ...convertFilterModel({
            filterModel: gridApi.current.getFilterModel() || {},
          }),
          // Add exclusion filter for deselected rows
          ...(deselectedRows.size > 0
            ? [
                {
                  field: "id",
                  operator: "notIn" as const,
                  value: Array.from(deselectedRows),
                },
              ]
            : []),
        ],
      };

      const fn =
        l1 && l2
          ? performBulkEditTagLevel({
              l1,
              l2,
              operation,
              params: filterParams,
              transactionIds: [], // Empty array since we're using filters
            })
          : job && job.id
          ? performBulkEdit({
              jobId: job.id,
              operation,
              params: filterParams,
              transactionIds: [], // Empty array since we're using filters
            })
          : Promise.resolve({ transactions: [] });

      return fn
        .then(({ transactions }) => {
          dispatch(toggleLoading());
          dispatch(fetchMfs());
          dispatch(fetchTotals());

          if (gridApi.current) {
            gridApi.current.purgeInfiniteCache();
          }

          dispatch(
            createAlert({
              message: "Correction made successfully",
              timeout: 0,
              type: "success",
            })
          );
        })
        .catch((err) => {
          dispatch(toggleLoading());
          dispatch(
            createAlert({
              message: "Error making correction",
              timeout: 0,
              type: "error",
            })
          );
        });
    } else {
      // Original implementation for specific transaction IDs
      dispatch(toggleLoading());
      const fn =
        l1 && l2
          ? performBulkEditTagLevel({
              l1,
              l2,
              operation,
              params: {},
              transactionIds,
            })
          : job && job.id
          ? performBulkEdit({
              jobId: job.id,
              operation,
              params: {},
              transactionIds,
            })
          : Promise.resolve({ transactions: [] });
      return fn
        .then(({ transactions }) => {
          dispatch(toggleLoading());
          dispatch(fetchMfs());
          dispatch(fetchTotals());

          if (gridApi.current) {
            gridApi.current.purgeInfiniteCache();
          }

          dispatch(
            createAlert({
              message: "Correction made successfully",
              timeout: 0,
              type: "success",
            })
          );
        })
        .catch((err) => {
          dispatch(toggleLoading());
          dispatch(
            createAlert({
              message: "Error making correction",
              timeout: 0,
              type: "error",
            })
          );
        });
    }
  };

  const handleSelectAll = useCallback(() => {
    if (!gridApi.current) return;
    setIsSelectAllPages(true);
    setDeselectedRows(new Set()); // Reset deselected rows
    const totalRows = gridApi.current.getInfiniteRowCount();
    setTotalRowCount(totalRows || 0);
    gridApi.current.forEachNode((node) => {
      node.setSelected(true);
    });
  }, []);

  const handleClearSelection = useCallback(() => {
    if (!gridApi.current) return;
    setIsSelectAllPages(false);
    setTotalRowCount(0);
    setDeselectedRows(new Set()); // Reset deselected rows
    gridApi.current.deselectAll();
  }, []);

  // console.log({ page: pagination.page });

  // Show empty state if no job documents
  if ((!jobDocs || jobDocs.length === 0) && !loading) {
    return (
      <div>
      {!hideJobButtons && (
        <Row className="justify-content-end text-right p-2">
          <TransactionManagerTourAndReportIssue />
          <HelpDrawer docType="bank" />
          <DownloadModal jobType={"bank"} btnVariant={"primary"} />
        </Row>
      )}
        <Row>
          <Col md="12">
            <EmptyStateComponent />
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div>
      {/* {l1 && l2 && ( */}
      {!hideJobButtons && (
        <Row className="justify-content-end text-right p-2">
          <TransactionManagerTourAndReportIssue />
          <HelpDrawer docType="bank" />
          <DownloadModal jobType={"bank"} btnVariant={"primary"} />
        </Row>
      )}
      <Row>
        <Col md="12">
          <div className="new-account-summary pl-3 pr-2">
            <SummaryTableAccountViewHorizontal2 />
          </div>
        </Col>
      </Row>
      <Row>
        <Col md="12" className="new-transactions">
          <Split
            sizes={isCSV ? [0, 100] : [40, 60]}
            direction="horizontal"
            style={{ display: "flex", height: "90vh" }}
          >
            {!isCSV && (
              <div style={{ width: "100%" }} className="mr-2">
                {/* Key by l1-l2-documentId so viewer remounts when project changes and does not show stale PDF */}
                {selectedDocumentId && (
                  <PresignedDocumentViewer
                    key={`${l1 ?? ""}-${l2 ?? ""}-${selectedDocumentId}`}
                    documentId={selectedDocumentId}
                  />
                )}
              </div>
            )}
            <div style={{ width: "100%" }} className="ml-4 transaction-manager">
              <Row>
                <Col md="6">
                  <Row className="align-items-center">
                    <span className="mr-2">Filter by</span>
                    <ExternalFilter
                      columnDefs={externalFilterColumns}
                      gridApi={gridApi.current}
                    />
                    {/* <div className="ml-4 d-flex align-items-center">
                      <div
                        className="ai-generated-legend"
                        style={{
                          width: "20px",
                          height: "12px",
                          backgroundColor: "#e8f4fd",
                          border: "1px solid #007bff",
                          marginRight: "5px",
                        }}
                      ></div>
                      <small className="text-muted">
                        AI-generated transactions
                      </small>
                    </div> */}
                  </Row>
                </Col>
                <Col md="6">
                  <Row className="d-flex justify-content-end align-items-center">
                    {/* <div className="mr-2">
                      <PayeeCleanerConfig />
                    </div> */}
                    <Button
                      variant="light"
                      onClick={handleShow}
                      className="mx-2"
                      // size="sm"
                    >
                      <FontAwesomeIcon icon="cog" className="mr-2" />
                      Configure Columns
                    </Button>

                    <div className="mx-2">
                      <AddTransactionModal
                        buttonVariant="light"
                        extended={true}
                        onTransactionAdded={() => {
                          if (gridApi.current) {
                            gridApi.current.purgeInfiniteCache();
                          }
                        }}
                      />
                    </div>
                    {(isSupportRep || isAdmin) && (
                      <FixBankPageWithAIButton
                        selectedDocumentId={selectedDocumentId}
                        jobDocs={jobDocs || []}
                        variant="outline-success"
                        size="sm"
                        className="mb-2 mx-2"
                      />
                    )}
                  </Row>
                </Col>
              </Row>

              <Modal show={showColumnSelectorModal} onHide={handleClose}>
                <Modal.Header
                  closeButton
                  placeholder=""
                  onPointerEnterCapture={() => {}}
                  onPointerLeaveCapture={() => {}}
                >
                  <Modal.Title>Configure Columns</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <ColumnSelector tableId={tableId} />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>

              <AgBulkTable
                onSetApi={(api) => (gridApi.current = api)}
                columnDefs={initialColumnDefs}
                bulkOpsClassName={"new-transactions-bulk-operations"}
                getRowClass={getRowClass}
                rowData={undefined}
                onRowSelected={(event) => {
                  if (isSelectAllPages && event.node.data) {
                    const rowId = event.node.data.id;
                    setDeselectedRows((prev) => {
                      const newSet = new Set(prev);
                      if (!event.node.isSelected()) {
                        newSet.add(rowId);
                      } else {
                        newSet.delete(rowId);
                      }
                      return newSet;
                    });
                  }
                }}
                // onGridReady={() => {
                //   if (isSelectAllPages && gridApi.current) {
                //     gridApi.current.forEachNode((node) => {
                //       if (node.data && !deselectedRows.has(node.data.id)) {
                //         node.setSelected(true);
                //       }
                //     });
                //   }
                // }}
                onPaginationChanged={() => {
                  if (isSelectAllPages && gridApi.current) {
                    gridApi.current.forEachNode((node) => {
                      if (node.data && !deselectedRows.has(node.data.id)) {
                        node.setSelected(true);
                      }
                    });
                  }
                }}
                renderBulkOps={(data, setSelectedRowsIds) => {
                  const transactionIds = data.map((x) => x.id);
                  const hasSelection = data.length > 0;
                  const selectionText = isSelectAllPages
                    ? deselectedRows.size > 0
                      ? `${
                          totalRowCount - deselectedRows.size
                        } transactions selected`
                      : `${totalRowCount} transactions selected`
                    : `${data.length} transactions selected`;

                  return (
                    <>
                      <Row className="justify-content-between mb-2 bulk-edit-buttons">
                        <Col md="10">
                          <Row>
                            <div className="d-flex align-items-center mr-5">
                              <Button
                                variant="light"
                                onClick={handleSelectAll}
                                className="m-1"
                              >
                                <FontAwesomeIcon icon="check-square" />
                                <span className="ml-1">
                                  Select All Transactions
                                </span>
                              </Button>

                              <Button
                                variant="light"
                                onClick={handleClearSelection}
                                className="m-1"
                                disabled={!hasSelection}
                              >
                                <FontAwesomeIcon icon="times" />
                                <span className="ml-1">Clear Selection</span>
                              </Button>

                              {hasSelection && (
                                <span className="ml-3">{selectionText}</span>
                              )}
                            </div>

                            <div className="d-flex align-items-center">
                              <SelectAccount2
                                transactionIds={transactionIds}
                                setSelectionError={() => null}
                                onDone={() => {
                                  setSelectedRowsIds([]);
                                  if (gridApi.current) {
                                    gridApi.current.purgeInfiniteCache();
                                  }
                                }}
                              />
                              <Button
                                disabled={!hasSelection}
                                variant="light"
                                onClick={() =>
                                  bulkEditHelper(
                                    "switchSigns",
                                    transactionIds
                                  ).then(() => {
                                    if (setSelectedRowsIds) {
                                      setSelectedRowsIds({});
                                    }
                                  })
                                }
                                className="mx-1"
                              >
                                <FontAwesomeIcon icon="random" />
                                <span className="ml-1">
                                  Switch credits/debits
                                </span>
                              </Button>
                              <Button
                                disabled={!hasSelection}
                                variant="light"
                                onClick={() =>
                                  bulkEditHelper(
                                    "switchIncludedExcluded",
                                    transactionIds
                                  ).then(() => {
                                    if (setSelectedRowsIds) {
                                      setSelectedRowsIds({});
                                    }
                                  })
                                }
                                className="mx-1"
                              >
                                <FontAwesomeIcon icon="random" />
                                <span className="ml-1">
                                  Switch included/excluded
                                </span>
                              </Button>
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  );
                }}
                hasExport={false}
                height={"75vh"}
                width={"100%"}
                defaultColDef={defaultColDef}
                colResizeDefault="shift"
                singleClickEdit
                rowModelType={"infinite"}
                onColumnResized={onColumnResized}
                cacheBlockSize={pagination.pageSize}
                cacheOverflowSize={2}
                maxConcurrentDatasourceRequests={1}
                infiniteInitialRowCount={1}
                maxBlocksInCache={2}
                pagination={true}
                paginationPageSize={pagination.pageSize}
              />
            </div>
          </Split>
        </Col>
      </Row>
    </div>
  );
};
export default NewTransactionManager;
